export default "__VITE_ASSET__66880571__$_?nuxt_component=async__"